import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import withRouterCustom from 'utils/hoc/withRouterCustom'

import {
  changeRetailerSearchText,
  setSelectedRetailerId,
} from 'store/orderList/duplicateOrdersModal/actions'
import {
  getRetailerSearchText,
  getSelectedRetailerId,
} from 'store/orderList/duplicateOrdersModal/selectors'
import { setShouldUpdateCart } from 'store/shop/actions'

import DuplicateOrdersModal from './DuplicateOrdersModal.component'
import { withConnectedRetailers } from './DuplicateOrdersModal.queries'

const mapStateToProps = (state) => ({
  selectedRetailerId: getSelectedRetailerId(state),
  retailerSearchText: getRetailerSearchText(state),
})

const mapDispatchToProps = (dispatch) => ({
  setSelectedRetailerId: (retailerId) =>
    dispatch(setSelectedRetailerId(retailerId)),
  changeRetailerSearchText: (searchText) =>
    dispatch(changeRetailerSearchText(searchText)),
  setShouldUpdateCart: (shouldUpdateCart) =>
    dispatch(setShouldUpdateCart(shouldUpdateCart)),
})

const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withRouterCustom,
  withConnectedRetailers,
)(DuplicateOrdersModal)
